import { useState , useEffect } from 'react';
import Search from '../components/Dashboard/Search.js';
import config from '../constants/config.js';
import './../styles/Dashboard.css';
import TemplatesTable from '../components/Dashboard/TemplatesTable.js';

function Templates() {
    const [ templates , setTemplates ] = useState( [] );
    const [ loadingTable , setLoadingTable ] = useState( false );
    const [ reloadTable , setReloadTable ] = useState( 0 );

    useEffect( () => {
        async function load() {
            setLoadingTable( true );

            /**
             * Load Templates. 
             */
            const _templates = await getTemplates();
            if ( _templates.length > 0 ) {
                setTemplates( _templates );
            }

            setLoadingTable( false );
        }

        load();
    } , [ reloadTable ] );

    async function getTemplates() {
        let templates = [];

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/templates`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            
            const response = await fetch( url , requestSettings );
            const data = await response.json();

            if ( data?.templates != null && data?.templates?.length > 0 ) {
                templates = data.templates;
            }
        } catch ( error ) {
            console.log( error );
        }

        return templates;
    }

    return(
        <div className="dashboard-wrapper">
            <div className="dashboard-header">
                <div className="actions-row">
                    <div className="actions-group">
                       
                    </div>
                    <div className="actions-group">
                        <Search />
                    </div>
                </div>
            </div>
            <div className="dashboard-body">
                <h1 className="dashboard-title">Templates</h1>
                <TemplatesTable 
                    templates={templates}
                    loading={loadingTable}
                    onUpdate={() => {
                        setTemplates( [] );
                        setReloadTable( reloadTable + 1 );
                    }}
                />
            </div>
        </div>
    );
}

export default Templates;